<div class="alert-filters">
  <mat-form-field>
    <mat-icon matIconPrefix class="material-symbols-outlined" (click)="search()" style="cursor: pointer">
      search
    </mat-icon>
    @if (searchControl.value) {
      <mat-icon matIconSuffix class="material-symbols-outlined" (click)="clearSearch()" style="cursor: pointer">
        close
      </mat-icon>
    }
    <input matInput placeholder="Filter by message..." [formControl]="searchControl" (keydown.enter)="search()" />
  </mat-form-field>
  <mat-form-field>
    <mat-select [(value)]="selectedLevel" (selectionChange)="search()">
      <mat-option value="">All levels</mat-option>
      @for (level of levels; track level) {
        <mat-option [value]="level">{{ levelMeta(level).label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-select [(value)]="selectedStatus" (selectionChange)="search()">
      <mat-option value="">All statuses</mat-option>
      @for (status of statuses; track status) {
        <mat-option [value]="status">{{ statusMeta(status).label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
